import { render } from "./AutoDownload.vue?vue&type=template&id=3628989c&scoped=true"
import script from "./AutoDownload.vue?vue&type=script&lang=js"
export * from "./AutoDownload.vue?vue&type=script&lang=js"

import "./AutoDownload.vue?vue&type=style&index=0&id=3628989c&scoped=true&lang=css"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3628989c"]])

export default __exports__